'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditprogress = require('./auditprogress.html');

var _auditprogress2 = _interopRequireDefault(_auditprogress);

var _auditprogress3 = require('./auditprogress.controller');

var _auditprogress4 = _interopRequireDefault(_auditprogress3);

require('./auditprogress.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogressComponent = {
  restrict: 'E',
  bindings: {},
  template: _auditprogress2.default,
  controller: _auditprogress4.default,
  controllerAs: 'vm'
};

exports.default = auditprogressComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogress/auditprogress.component.js